import { LumappsTrackingEventContext } from '@lumapps/analytics-tracking/types';
import { getEventBaseData } from '@lumapps/analytics-tracking/utils';

import { sendUserFeedback } from './api';
import { LumappsUserFeedbackActionType, LumappsUserFeedbackEvent, LumappsUserFeedbackEventPayload } from './types';

const fillAndSendLumappsUserFeedbackEvent = (
    eventActions: LumappsUserFeedbackActionType[],
    overrideContext: Partial<Pick<LumappsTrackingEventContext, 'locale' | 'referrer'>> = {},
) => {
    const eventBaseData = getEventBaseData();

    const data: Record<string, LumappsUserFeedbackEvent[]> = {
        events: eventActions.map((eventAction) => ({
            ...eventBaseData,
            action: eventAction,
            ...overrideContext,
        })),
    };

    for (const event of data.events) {
        sendUserFeedback(event);
    }
};

export const lumappsUserFeedbackPlugin = {
    sendUserFeeback: ({
        payload,
    }: {
        payload: LumappsUserFeedbackEventPayload | LumappsUserFeedbackEventPayload[];
    }) => {
        const actions = Array.isArray(payload) ? payload.map((p) => p.action) : [payload.action];
        fillAndSendLumappsUserFeedbackEvent(actions);
    },
};
